import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import Signin from "@/pages/UserManagement/Signin.vue";
import Register from "@/pages/UserManagement/Register.vue";
import Activate from "@/pages/UserManagement/Activate.vue";
import Payment from "@/pages/UserManagement/Payment.vue";
import ConfirmPurchase from "@/pages/UserManagement/ConfirmPurchase.vue";
import PasswordReset from "@/pages/UserManagement/PasswordReset.vue";
import LoginPasswordReset from "@/pages/UserManagement/LoginPasswordReset.vue";
import Box from "@/pages/Resources/Box.vue";
import BoxPreview from "@/pages/Resources/BoxPreview.vue";
import MeetingSignin from "@/pages/Events/MeetingSignin.vue";
import Calendar from "@/pages/Events/Calendar.vue";
import Rankings from "@/pages/Trading/Rankings.vue";
import TradingSplash from "@/pages/Trading/TradingSplash.vue";
import ManagePositions from "@/pages/Trading/ManagePositions.vue";
import Vote from "@/pages/Trading/Vote.vue";
import PitchResults from "@/pages/Internal/PitchResults.vue";
import AnalystGroupLanding from "@/pages/AnalystGroup/AnalystGroupLanding.vue";
import FundLanding from "@/pages/Fund/FundLanding.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: {requiresAuth: true},
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "user",
        name: "User Profile",
        component: UserProfile
      },
      {
        path: "meetings",
        name: "Meetings",
        component: MeetingSignin
      },
      {
        path: "payment",
        name: "Payment",
        component: Payment
      },
      {
        path: "box",
        name: "Box",
        component: Box,
        meta: {requiresPaid: true},
      },
      {
        path: "box-preview",
        name: "Box Preview",
        component: BoxPreview
      },
      {
        path: "calendar",
        name: "Calendar",
        component: Calendar
      },
      {
        path: "vote",
        name: "Vote",
        component: Vote
      },
      {
        path: "positions",
        name: "Positions",
        component: ManagePositions
      },
      {
        path: "rankings",
        name: "Rankings",
        component: Rankings
      },
      {
        path: "pitch_results",
        name: "Pitch Results",
        component: PitchResults
      },
      {
        path: "analyst_groups",
        name: "Analyst Groups",
        component: AnalystGroupLanding,
        meta: {requiresPaid: true}
      },
      {
        path: "industry_funds",
        name: "Industry Funds",
        component: FundLanding,
        meta: {requiresPaid: true}
      }
    ]
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  },
  {
    path: "/loginreset",
    name: "Login Reset",
    component: LoginPasswordReset
  },
  {
    path: "/activation/:token",
    name: "Activation",
    component: Activate
  },
  {
    path: "/passwordreset/:token",
    name: "PasswordReset",
    component: PasswordReset
  },
  {
    path: "/confirm_purchase/:token",
    name: "ConfirmPurchase",
    component: ConfirmPurchase
  },
  {
    path: '*',
    redirect: {
      name: 'Dashboard'
    },
  }

];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js